import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import { Units, Colors } from 'Css';
import { Toggle } from 'material-ui';

const css = oxygenCss({
  root: {
    padding: Units.base,
    color: Colors.fullWhite
  }
});

class StoreSectionEditor extends Component {
  static propTypes = {
    id: PropTypes.string,
    type: PropTypes.string
  };

  changeType = event => {
    const { checked } = event.target;
    const { id } = this.props;
    StoreOverviewActions.updateSection(id, {
      type: checked ? 'banner' : 'default'
    });
  };

  render() {
    const { type } = this.props;
    const fullWidth = type === 'banner';
    return (
      <div className={css.root}>
        <Toggle
          labelStyle={{ color: Colors.fullWhite }}
          label={'Full width'}
          toggled={fullWidth}
          onToggle={this.changeType}
        />
      </div>
    );
  }
}

export default StoreSectionEditor;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/StoreSectionEditor.js